import React, { useEffect, useState, Suspense, useCallback } from 'react'
import { Text } from 'react-native'
import { useAtom } from 'jotai'
import { ScreenLayout, SecureStore } from '@libs/utils'
import { useIsFocused } from '@react-navigation/native'
import DesktopView from './DesktopView'
import MobileView from './MobileView'
import { brandDetailsAtom } from '../../utils'

const VerifyAccount = () => {
  const [brandLogoUrl, setBrandLogoUrl] = useState('')
  const isFocused = useIsFocused()
  const LayoutView = useCallback(
    ScreenLayout.withLayoutView(DesktopView, MobileView, MobileView),
    [],
  )

  useEffect(() => {
    if (!isFocused) return
    ;(async () => {
      const configData = await SecureStore.getItemAsync('config')
      const config = JSON.parse(configData)?.config
      setBrandLogoUrl(config?.brandLogoUrl)
    })()
  }, [isFocused])

  const [brandDetails] = useAtom(brandDetailsAtom)

  const viewProps = {
    brandDetails,
    brandLogoUrl,
    label: 'Verifying Your Account...',
  }

  return (
    <Suspense fallback={<Text>Loading</Text>}>
      <LayoutView {...viewProps} />
    </Suspense>
  )
}

export default VerifyAccount
